export const initialState = { value: "", errorMessage: "" }
